export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5415.111e19a0.jpg";